<template>
    <tr :class="['clickable', { disabled: !isActive, updated: isLastVisited(cron.id) }]" @click="goToDetail($event, cron.id)">
        <td class="no_padding drag_drop"><span></span></td>
        <td :data-th="'Název' | translate" class="first_data"><strong>{{ cron.title }}</strong></td>
        <td :data-th="'Popis' | translate" class="first_data">{{ cron.description }}</td>
        <td :data-th="'Celkový počet běhů' | translate" class="first_data">{{ cron.total_runs }}</td>
        <td :data-th="'Počet běhů za posledních 24h' | translate" class="first_data">{{ cron.total_runs_last_24_h }}</td>
        <td :data-th="'Poslední status' | translate" class="first_data">{{ cron.last_status }}</td>
        <td :data-th="'Poslední výsledek' | translate" class="first_data">
            <img :class="['is_set']" src="../../../assets/images/is-set.svg" :alt="'Ano' | translate" v-if="cron.last_result === 'ok'">
            <img :class="['is_set']" src="../../../assets/images/isnot-set.svg" :alt="'Ne' | translate" v-else-if="cron.last_result === 'error'">
        </td>
        <td>
          <div v-if="$_updateActionAllowed">
            <input
                    v-if="cron.last_status === 'running'"
                    type="submit"
                    :class="['btn']"
                    :value="$gettext('Odemknout')"
                    @click.prevent.stop="emitUnlockCron()">
            <input
                    v-else
                    type="submit"
                    :class="['btn']"
                    :value="$gettext('Spustit')"
                    @click.prevent.stop="emitRunCron()">
          </div>
        </td>
        <td class="no_padding edit">
            <div class="edit_inner" v-if="$_updateActionAllowed">
                <a
                        v-if="!isActive"
                        class="btn btn_action btn_grey btn_enable"
                                                :title="'Aktivovat' | translate"
                        @click.prevent.stop="emitUpdateCron({enabled: true})"
                        v-translate>Aktivovat
                </a>
                <a
                        v-else class="btn btn_action btn_grey btn_disable"
                                                :title="'Deaktivovat' | translate"
                        @click.prevent.stop="emitUpdateCron({enabled: false})"
                        v-translate>Deaktivovat
                </a>
            </div>
        </td>
    </tr>
</template>

<script>
	import userSettings from "@/components/mixins/user-settings"

	export default {
		name: "CronRow",
        mixins: [userSettings],
		data() {
			return {
				moduleName: 'crons',
			}
		},
		props: {
			cron: Object,
		},
        computed: {
			cronId() {
				return String(this.cron.id)
			},
            isActive() {
				return this.cron.enabled
            }
		},
		methods: {
			goToDetail(e, id) {
				this.$router.push({name: 'cronDetail', params: {id: id}})
			},
			emitUpdateCron(params) {
				this.$emit('updateCron', {'id': this.cron.id, 'params': params})
			},
			// emitDeleteCron() {
			// 	this.$emit('deleteCron', this.cronId)
			// },
            emitRunCron() {
				this.cron.last_status = 'running'
                this.$emit('runCron', this.cronId)
            },
            emitUnlockCron() {
				this.$emit('unlockCron', this.cronId)
            }
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/views/crons/CronRow.vue